import ActionTypes from '../constants/ActionTypes';

export const getDesmondProblemData = problem => ({
  type: ActionTypes.SET_DESMOND_PROBLEM_DATA,
  problem,
});
export const runDesmondCodeCustomInput = (
  problem,
  technology,
  solutionId,
  solutionSlug
) => ({
  type: ActionTypes.RUN_DESMOND_CODE_CUSTOM_INPUT,
  problem,
  technology,
  solutionId,
  solutionSlug,
});

export const runProject = (
  problem,
  technology,
  solutionId,
  solutionSlug,
  filePath
) => ({
  type: ActionTypes.RUN_PROJECT,
  problem,
  technology,
  solutionId,
  solutionSlug,
  filePath,
});

export const runProjectResult = data => ({
  type: `${ActionTypes.RUN_PROJECT}_RESULT`,
  data,
});

export const runVerifyTestCasesResult = data => ({
  type: ActionTypes.RUN_VERIFY_TEST_CASES_RESULT,
  data,
});
